<template>
  <router-link
    :to="{ name: routeName }"
    class="tw-flex tw-justify-between tw-items-center tw-text-gray hover:tw-text-primary tw-cursor-pointer tw-py-5"
    :class="{
      'tw-text-primary': $route.name === routeName,
    }"
    @click="clicked"
  >
    <span class="tw-flex tw-items-center">
      <svg
        v-if="title === 'Company Information'"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_5056_24526)">
          <path
            d="M16.3825 5.01099V1.31868H8.83959V5.01099H0.611023V10.5495H24.611V5.01099H16.3825ZM10.422 2.9011H14.8V5.01099H10.422V2.9011Z"
            :fill="$route.name === routeName ? '#2A62F5' : '#8791A7'"
          />
          <path
            d="M15.2484 15.2967H9.97366V12.1319H0.611023V22.6813H24.611V12.1319H15.2484V15.2967Z"
            :fill="$route.name === routeName ? '#2A62F5' : '#8791A7'"
          />
          <path
            d="M13.666 12.1319H11.5561V13.7143H13.666V12.1319Z"
            :fill="$route.name === routeName ? '#2A62F5' : '#8791A7'"
          />
        </g>
        <defs>
          <clipPath id="clip0_5056_24526">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0.611023)"
            />
          </clipPath>
        </defs>
      </svg>
      <svg
        v-if="title === 'Identity Verification'"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.39408 2.826L12.6111 1L20.8281 2.826C21.0501 2.87536 21.2487 2.99897 21.3911 3.1764C21.5334 3.35384 21.611 3.57452 21.6111 3.802V13.789C21.611 14.7767 21.3671 15.7492 20.901 16.62C20.4349 17.4908 19.761 18.2331 18.9391 18.781L12.6111 23L6.28308 18.781C5.46136 18.2332 4.78754 17.4911 4.32143 16.6205C3.85532 15.7498 3.61132 14.7776 3.61108 13.79V3.802C3.61112 3.57452 3.68872 3.35384 3.83107 3.1764C3.97343 2.99897 4.17202 2.87536 4.39408 2.826ZM12.6111 11C13.2741 11 13.91 10.7366 14.3789 10.2678C14.8477 9.79893 15.1111 9.16304 15.1111 8.5C15.1111 7.83696 14.8477 7.20107 14.3789 6.73223C13.91 6.26339 13.2741 6 12.6111 6C11.948 6 11.3122 6.26339 10.8433 6.73223C10.3745 7.20107 10.1111 7.83696 10.1111 8.5C10.1111 9.16304 10.3745 9.79893 10.8433 10.2678C11.3122 10.7366 11.948 11 12.6111 11ZM8.13808 16H17.0841C16.9629 14.8984 16.4394 13.8803 15.614 13.1407C14.7886 12.4012 13.7193 11.9922 12.6111 11.9922C11.5028 11.9922 10.4336 12.4012 9.60816 13.1407C8.78277 13.8803 8.2593 14.8984 8.13808 16Z"
          :fill="$route.name === routeName ? '#2A62F5' : '#8791A7'"
        />
      </svg>
      <svg
        v-if="title === 'Manage Features'"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 11.5C6.40905 11.5 5.82389 11.3836 5.27792 11.1575C4.73196 10.9313 4.23588 10.5998 3.81802 10.182C3.40016 9.76412 3.06869 9.26804 2.84254 8.72208C2.6164 8.17611 2.5 7.59095 2.5 7C2.5 6.40905 2.6164 5.82389 2.84254 5.27792C3.06869 4.73196 3.40016 4.23588 3.81802 3.81802C4.23588 3.40016 4.73196 3.06869 5.27792 2.84254C5.82389 2.6164 6.40905 2.5 7 2.5C8.19347 2.5 9.33807 2.97411 10.182 3.81802C11.0259 4.66193 11.5 5.80653 11.5 7C11.5 8.19347 11.0259 9.33807 10.182 10.182C9.33807 11.0259 8.19347 11.5 7 11.5ZM7 21.5C5.80653 21.5 4.66193 21.0259 3.81802 20.182C2.97411 19.3381 2.5 18.1935 2.5 17C2.5 15.8065 2.97411 14.6619 3.81802 13.818C4.66193 12.9741 5.80653 12.5 7 12.5C8.19347 12.5 9.33807 12.9741 10.182 13.818C11.0259 14.6619 11.5 15.8065 11.5 17C11.5 18.1935 11.0259 19.3381 10.182 20.182C9.33807 21.0259 8.19347 21.5 7 21.5ZM17 11.5C16.4091 11.5 15.8239 11.3836 15.2779 11.1575C14.732 10.9313 14.2359 10.5998 13.818 10.182C13.4002 9.76412 13.0687 9.26804 12.8425 8.72208C12.6164 8.17611 12.5 7.59095 12.5 7C12.5 6.40905 12.6164 5.82389 12.8425 5.27792C13.0687 4.73196 13.4002 4.23588 13.818 3.81802C14.2359 3.40016 14.732 3.06869 15.2779 2.84254C15.8239 2.6164 16.4091 2.5 17 2.5C18.1935 2.5 19.3381 2.97411 20.182 3.81802C21.0259 4.66193 21.5 5.80653 21.5 7C21.5 8.19347 21.0259 9.33807 20.182 10.182C19.3381 11.0259 18.1935 11.5 17 11.5ZM17 21.5C15.8065 21.5 14.6619 21.0259 13.818 20.182C12.9741 19.3381 12.5 18.1935 12.5 17C12.5 15.8065 12.9741 14.6619 13.818 13.818C14.6619 12.9741 15.8065 12.5 17 12.5C18.1935 12.5 19.3381 12.9741 20.182 13.818C21.0259 14.6619 21.5 15.8065 21.5 17C21.5 18.1935 21.0259 19.3381 20.182 20.182C19.3381 21.0259 18.1935 21.5 17 21.5Z"
          :fill="$route.name === routeName ? '#2A62F5' : '#8791A7'"
        />
      </svg>
      <svg
        v-if="title === 'Profile Summary'"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 21.6562H12V18.6562H0V21.6562ZM0 16.6547H24V13.6547H0V16.6547ZM0 11.6578H24V8.65781H0V11.6578ZM0 3.65625V6.65625H24V3.65625H0Z"
          :fill="$route.name === routeName ? '#2A62F5' : '#8791A7'"
        />
      </svg>

      <svg
        v-if="title === 'Live Chat'"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 18H18.237L20 19.385V9H21C21.2652 9 21.5196 9.10536 21.7071 9.29289C21.8946 9.48043 22 9.73478 22 10V23.5L17.545 20H9C8.73478 20 8.48043 19.8946 8.29289 19.7071C8.10536 19.5196 8 19.2652 8 19V18ZM5.455 16L1 19.5V4C1 3.73478 1.10536 3.48043 1.29289 3.29289C1.48043 3.10536 1.73478 3 2 3H17C17.2652 3 17.5196 3.10536 17.7071 3.29289C17.8946 3.48043 18 3.73478 18 4V16H5.455Z"
          :fill="$route.name === routeName ? '#2A62F5' : '#8791A7'"
        />
      </svg>
      <svg
        v-if="title === 'Founders\' Information'"
        width="16"
        height="21"
        viewBox="0 0 16 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 21C0 18.8783 0.842855 16.8434 2.34315 15.3431C3.84344 13.8429 5.87827 13 8 13C10.1217 13 12.1566 13.8429 13.6569 15.3431C15.1571 16.8434 16 18.8783 16 21H0ZM8 12C4.685 12 2 9.315 2 6C2 2.685 4.685 0 8 0C11.315 0 14 2.685 14 6C14 9.315 11.315 12 8 12Z"
          :fill="$route.name === routeName ? '#2A62F5' : '#8791A7'"
        />
      </svg>
      <svg
        v-if="title === 'Company Updates'"
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 15H20V17H0V15H2V8C2 5.87827 2.84285 3.84344 4.34315 2.34315C5.84344 0.842855 7.87827 0 10 0C12.1217 0 14.1566 0.842855 15.6569 2.34315C17.1571 3.84344 18 5.87827 18 8V15ZM7 19H13V21H7V19Z"
          :fill="$route.name === routeName ? '#2A62F5' : '#8791A7'"
        />
      </svg>

      <svg
        v-if="title === 'Manage Bank'"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.333252 12.3334H13.6666V13.6667H0.333252V12.3334ZM1.66659 7.00004H2.99992V11.6667H1.66659V7.00004ZM4.99992 7.00004H6.33325V11.6667H4.99992V7.00004ZM7.66659 7.00004H8.99992V11.6667H7.66659V7.00004ZM10.9999 7.00004H12.3333V11.6667H10.9999V7.00004ZM0.333252 3.66671L6.99992 0.333374L13.6666 3.66671V6.33337H0.333252V3.66671ZM6.99992 4.33337C7.17673 4.33337 7.3463 4.26314 7.47132 4.13811C7.59635 4.01309 7.66659 3.84352 7.66659 3.66671C7.66659 3.4899 7.59635 3.32033 7.47132 3.1953C7.3463 3.07028 7.17673 3.00004 6.99992 3.00004C6.82311 3.00004 6.65354 3.07028 6.52851 3.1953C6.40349 3.32033 6.33325 3.4899 6.33325 3.66671C6.33325 3.84352 6.40349 4.01309 6.52851 4.13811C6.65354 4.26314 6.82311 4.33337 6.99992 4.33337Z"
          :fill="$route.name === routeName ? '#2A62F5' : '#8791A7'"
        />
      </svg>
      <svg
        v-if="title === 'Login & Security'"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17 13V14C17 16.77 16.336 19.445 15.085 21.846L14.858 22.266L13.111 21.292C14.271 19.212 14.921 16.882 14.993 14.456L15 14V13H17ZM11 10H13V14L12.995 14.379C12.9194 17.1167 11.9772 19.7598 10.304 21.928L10.073 22.218L8.523 20.954C10.0494 19.0899 10.918 16.7741 10.994 14.366L11 14V10ZM12 6.00001C13.3261 6.00001 14.5979 6.52679 15.5355 7.46448C16.4732 8.40216 17 9.67393 17 11H15C15 10.2044 14.6839 9.4413 14.1213 8.87869C13.5587 8.31608 12.7956 8.00001 12 8.00001C11.2043 8.00001 10.4413 8.31608 9.87868 8.87869C9.31607 9.4413 9 10.2044 9 11V14C9 16.235 8.18 18.344 6.729 19.977L6.517 20.207L5.069 18.827C6.23896 17.6029 6.92324 15.9948 6.994 14.303L7 14V11C7 9.67393 7.52678 8.40216 8.46447 7.46448C9.40215 6.52679 10.6739 6.00001 12 6.00001ZM12 2.00001C14.3869 2.00001 16.6761 2.94822 18.364 4.63605C20.0518 6.32388 21 8.61306 21 11V14C21 15.698 20.798 17.37 20.403 18.99L20.264 19.529L18.334 19.003C18.726 17.566 18.947 16.081 18.992 14.568L19 14V11C19 9.70087 18.6385 8.42737 17.9559 7.32201C17.2733 6.21666 16.2965 5.32307 15.135 4.74125C13.9734 4.15943 12.6728 3.91233 11.3788 4.02762C10.0848 4.1429 8.84842 4.61601 7.808 5.39401L6.383 3.96801C7.97647 2.69129 9.95815 1.99698 12 2.00001ZM4.968 5.38301L6.394 6.80801C5.53633 7.95124 5.05106 9.3306 5.004 10.759L5 11L5.004 13C5.004 14.12 4.74 15.203 4.242 16.177L4.086 16.467L2.349 15.475C2.729 14.81 2.951 14.068 2.995 13.292L3.004 13V11C2.99807 8.95834 3.69115 6.97615 4.968 5.38301Z"
          :fill="$route.name === routeName ? '#2A62F5' : '#8791A7'"
        />
      </svg>
      <svg
        v-if="title === 'Subscription Plans'"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.99992 13.6667C3.31792 13.6667 0.333252 10.682 0.333252 7.00004C0.333252 3.31804 3.31792 0.333374 6.99992 0.333374C10.6819 0.333374 13.6666 3.31804 13.6666 7.00004C13.6666 10.682 10.6819 13.6667 6.99992 13.6667ZM7.66659 7.00004V3.66671H6.33325V8.33337H10.3333V7.00004H7.66659Z"
          :fill="$route.name === routeName ? '#2A62F5' : '#8791A7'"
        />
      </svg>
      <svg
        v-if="title === 'Configurations'"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.11325 11C3.25099 10.6096 3.50641 10.2716 3.84432 10.0325C4.18223 9.7934 4.58598 9.665 4.99992 9.665C5.41386 9.665 5.81761 9.7934 6.15552 10.0325C6.49343 10.2716 6.74885 10.6096 6.88659 11H13.6666V12.3333H6.88659C6.74885 12.7237 6.49343 13.0617 6.15552 13.3008C5.81761 13.5399 5.41386 13.6683 4.99992 13.6683C4.58598 13.6683 4.18223 13.5399 3.84432 13.3008C3.50641 13.0617 3.25099 12.7237 3.11325 12.3333H0.333252V11H3.11325ZM7.11325 6.3333C7.25099 5.94294 7.50641 5.60492 7.84432 5.36582C8.18223 5.12673 8.58598 4.99833 8.99992 4.99833C9.41386 4.99833 9.81761 5.12673 10.1555 5.36582C10.4934 5.60492 10.7489 5.94294 10.8866 6.3333H13.6666V7.66663H10.8866C10.7489 8.05699 10.4934 8.39501 10.1555 8.63411C9.81761 8.8732 9.41386 9.0016 8.99992 9.0016C8.58598 9.0016 8.18223 8.8732 7.84432 8.63411C7.50641 8.39501 7.25099 8.05699 7.11325 7.66663H0.333252V6.3333H7.11325ZM3.11325 1.66663C3.25099 1.27628 3.50641 0.938255 3.84432 0.699158C4.18223 0.460062 4.58598 0.331665 4.99992 0.331665C5.41386 0.331665 5.81761 0.460062 6.15552 0.699158C6.49343 0.938255 6.74885 1.27628 6.88659 1.66663H13.6666V2.99997H6.88659C6.74885 3.39032 6.49343 3.72834 6.15552 3.96744C5.81761 4.20654 5.41386 4.33493 4.99992 4.33493C4.58598 4.33493 4.18223 4.20654 3.84432 3.96744C3.50641 3.72834 3.25099 3.39032 3.11325 2.99997H0.333252V1.66663H3.11325Z"
          :fill="$route.name === routeName ? '#2A62F5' : '#8791A7'"
        />
      </svg>
      <span
        class="tw-pl-3"
        :class="[$route.name === routeName ? 'tw-text-primary' : '#8791A7']"
        >{{ title }}</span
      >
    </span>
    <svg
      class="tw-hidden md:tw-block md:tw-ml-2"
      width="8"
      height="13"
      viewBox="0 0 8 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.95 6.364L0 1.414L1.414 0L7.778 6.364L1.414 12.728L0 11.314L4.95 6.364Z"
        :fill="$route.name === routeName ? '#2A62F5' : '#8791A7'"
      />
    </svg>
  </router-link>
</template>

<script>
export default {
  name: "AccountMenu",
  props: {
    title: { type: String, default: () => "", required: true },
    routeName: {
      type: String,
      required: false,
    },
    focus: { type: Boolean, default: () => false },
  },
  emits: ["clicked"],
  methods: {
    clicked() {
      this.$emit("clicked", this.title);
    },
  },
};
</script>

<style lang="scss" scoped></style>
